<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de tempo de espera">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-tempo-espera-create' })"
                    color="primary"
                    authorize="store-painel-senha-tempo-espera"
                >
                    Cadastrar tempo de espera
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/tempo-espera/List'

export default {
    components: { List },
}
</script>